module.exports = __webpack_public_path__ + "img/skip-forward-btn.c5ff92e3.svg";